import React, { memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { btnType } from "../../constant/dumpStartDraw";

import { LiveAudioControls, useLiveAudio } from "../liveAudio/LiveAudio";

const Welcome = (props) => {
    const { onStartDraw } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const liveAudio = useLiveAudio();

    const path = location.pathname.split("/")[2].split("-")[0];

    const onSetStartDraw = (result) => {
        if (liveAudio) void liveAudio.start();
        onStartDraw && onStartDraw(result)
    }

    const getLotteryTypeFromPath = (pathname) => {
        return pathname.split("/")[2].split("-")[0];
    };

    const lotteryType = getLotteryTypeFromPath(location.pathname)

    const onOpenResult = () => {
        navigate(`/result/${lotteryType}`);
    };

    const onBack = () => {
        if (location.pathname.startsWith("/live-v4/")) {
            navigate("/live-v4");
            return;
        }

        if (location.pathname.startsWith("/live-full/")) {
            navigate("/live-full");
            return;
        }

        if (location.pathname.startsWith("/live-v3")) {
            navigate("/live-v3");
            return;
        }

        if (location.pathname.includes("-black")) {
            navigate("/black");
            return;
        }

        navigate("/");
    };

    return <div className="w-100 h-100">
        <div className="w-100 h-100 d-flex justify-content-center align-items-center" style={{
            backgroundImage: `url(${require(`../../assets/images/live-v2/welcome/wel_bg.jpg`)})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%"

        }}>
            {!location.pathname.startsWith("/live-full/") && <button
                type="button"
                className="welcome-back-button"
                onClick={onBack}
            >
                Back
            </button>}
            <div>
                <div className="d-flex justify-content-center w-100">
                    <img src={require("../../assets/images/live-v2/welcome/welcome.png")} alt="_wel" />
                </div>

                <LiveAudioControls />
                <div className="d-flex justify-content-around align-items-center mt-4 gap-2">
                    {
                        btnType[path]?.map((item, i) => {
                            const { result, label } = item;
                            return <button key={i} className="button-start"
                                onClick={() => onSetStartDraw(result)}>{label}</button>
                        })
                    }
                    <button
                        className="button-start"
                        onClick={onOpenResult}
                    >
                        លទ្ធផល
                    </button>
                </div>
            </div>

        </div>
    </div>
}
export default memo(Welcome);
